// extracted by mini-css-extract-plugin
module.exports = {"customScroll":"userProfileSuperviseeProjectSelectMenuList_customScroll__1POFh"};